<template>
  <div>
    <div class="flex flex-col justify-center items-center">
      <p class="py-5 text-2xl font-semibold w-5/12 text-center">
        Select your physician criteria
      </p>
      <div class="my-10">
        <div class="grid grid-cols-3 gap-6">
          <div>
            <el-select
              style="width: 18rem;"
              v-model="specialty"
              placeholder="Specialty"
              multiple
            >
              <el-option
                v-for="item in allSpecialties"
                :key="item.specialties"
                :label="item.specialties"
                :value="item.specialties">
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select
              style="width: 18rem;"
              v-model="state_license"
              placeholder="State License"
              multiple
            >
              <el-option
                v-for="item in allLisense"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="mt-5 grid grid-cols-3 gap-6">
          <div>
            <el-select
              style="width: 18rem;"
              v-model="languages"
              placeholder="Languages"
              multiple
            >
              <el-option
                v-for="item in allLanguages"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div>
            <el-select
              style="width: 18rem;"
              v-model="insurance_coverage"
              placeholder="Insurance coverage"
              multiple
            >
              <el-option
                v-for="item in insuranceCoverage"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div>
            <button
              class="-mt-1 rounded-full bg-primary px-6
              py-2 text-white w-60 font-semibold focus:outline-none"
              @click="next"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center items-center my-20">
      <!-- <empty-state></empty-state> -->
      <div>
        <search-results></search-results>
        <div class="flex justify-between items-center mt-12">
          <button @click.prevent="back" class="flex items-center">
            <span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L6 8L10 4" stroke="#292929" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <span>Back</span>
          </button>
          <button @click.prevent="next" class="bg-primary px-16 py-2.5 rounded-full text-white">Confirm</button>
        </div>
      </div>
      <div class="border border-gray-200 p-5 shadow coverage">
        <div class="flex item-center justify-center mt-2">
          <span>
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.7601 8.51461C14.1276 8.09536 14.3312 7.55745 14.3334 6.99995C14.3334 6.38111 14.0876 5.78762 13.65 5.35003C13.2124 4.91245 12.6189 4.66661 12.0001 4.66661C11.3812 4.66661 10.7878 4.91245 10.3502 5.35003C9.91258 5.78762 9.66675 6.38111 9.66675 6.99995C9.66899 7.55745 9.8726 8.09536 10.2401 8.51461C9.76005 8.81217 9.36372 9.22708 9.08845 9.72023C8.81319 10.2134 8.66806 10.7685 8.66675 11.3333C8.66675 11.5101 8.73699 11.6797 8.86201 11.8047C8.98703 11.9297 9.1566 11.9999 9.33341 11.9999C9.51023 11.9999 9.67979 11.9297 9.80482 11.8047C9.92984 11.6797 10.0001 11.5101 10.0001 11.3333C10.0001 10.8028 10.2108 10.2941 10.5859 9.91907C10.9609 9.54399 11.4696 9.33328 12.0001 9.33328C12.5305 9.33328 13.0392 9.54399 13.4143 9.91907C13.7894 10.2941 14.0001 10.8028 14.0001 11.3333C14.0001 11.5101 14.0703 11.6797 14.1953 11.8047C14.3204 11.9297 14.4899 11.9999 14.6667 11.9999C14.8436 11.9999 15.0131 11.9297 15.1382 11.8047C15.2632 11.6797 15.3334 11.5101 15.3334 11.3333C15.3321 10.7685 15.187 10.2134 14.9117 9.72023C14.6364 9.22708 14.2401 8.81217 13.7601 8.51461ZM12.0001 7.99995C11.8023 7.99995 11.609 7.9413 11.4445 7.83142C11.2801 7.72153 11.1519 7.56536 11.0762 7.38263C11.0005 7.1999 10.9807 6.99884 11.0193 6.80486C11.0579 6.61087 11.1531 6.43269 11.293 6.29284C11.4328 6.15299 11.611 6.05775 11.805 6.01916C11.999 5.98058 12.2 6.00038 12.3828 6.07607C12.5655 6.15175 12.7217 6.27993 12.8315 6.44438C12.9414 6.60883 13.0001 6.80217 13.0001 6.99995C12.9997 7.26505 12.8943 7.5192 12.7068 7.70666C12.5193 7.89412 12.2652 7.99959 12.0001 7.99995ZM4.52875 3.13795L5.86208 4.47128C5.98782 4.59272 6.15622 4.65991 6.33102 4.6584C6.50581 4.65688 6.67302 4.58676 6.79663 4.46316C6.92023 4.33955 6.99034 4.17234 6.99186 3.99755C6.99338 3.82275 6.92619 3.65435 6.80475 3.52861L6.60941 3.33328H9.39075L9.19541 3.52861C9.13174 3.59011 9.08095 3.66367 9.04601 3.74501C9.01107 3.82635 8.99268 3.91383 8.99191 4.00235C8.99114 4.09087 9.00801 4.17865 9.04153 4.26058C9.07505 4.34251 9.12456 4.41695 9.18715 4.47954C9.24975 4.54214 9.32418 4.59164 9.40611 4.62516C9.48804 4.65868 9.57583 4.67555 9.66435 4.67478C9.75287 4.67401 9.84035 4.65562 9.92168 4.62068C10.003 4.58574 10.0766 4.53495 10.1381 4.47128L11.4714 3.13795C11.5957 3.01258 11.6655 2.84317 11.6655 2.66661C11.6655 2.49005 11.5957 2.32064 11.4714 2.19528L10.1381 0.861946C10.0123 0.740507 9.84394 0.673311 9.66915 0.67483C9.49435 0.676349 9.32714 0.746462 9.20354 0.870067C9.07993 0.993672 9.00982 1.16088 9.0083 1.33568C9.00678 1.51048 9.07398 1.67888 9.19541 1.80461L9.39075 1.99995H6.60941L6.80475 1.80461C6.92619 1.67888 6.99338 1.51048 6.99186 1.33568C6.99034 1.16088 6.92023 0.993672 6.79663 0.870067C6.67302 0.746462 6.50581 0.676349 6.33102 0.67483C6.15622 0.673311 5.98782 0.740507 5.86208 0.861946L4.52875 2.19528C4.40442 2.32064 4.33465 2.49005 4.33465 2.66661C4.33465 2.84317 4.40442 3.01258 4.52875 3.13795ZM5.76008 8.51461C6.12756 8.09536 6.33117 7.55745 6.33341 6.99995C6.33341 6.38111 6.08758 5.78762 5.65 5.35003C5.21241 4.91245 4.61892 4.66661 4.00008 4.66661C3.38124 4.66661 2.78775 4.91245 2.35017 5.35003C1.91258 5.78762 1.66675 6.38111 1.66675 6.99995C1.66899 7.55745 1.8726 8.09536 2.24008 8.51461C1.76005 8.81217 1.36372 9.22708 1.08845 9.72023C0.813186 10.2134 0.668056 10.7685 0.666748 11.3333C0.666748 11.5101 0.736986 11.6797 0.86201 11.8047C0.987034 11.9297 1.1566 11.9999 1.33341 11.9999C1.51023 11.9999 1.67979 11.9297 1.80482 11.8047C1.92984 11.6797 2.00008 11.5101 2.00008 11.3333C2.00008 10.8028 2.2108 10.2941 2.58587 9.91907C2.96094 9.54399 3.46965 9.33328 4.00008 9.33328C4.53051 9.33328 5.03922 9.54399 5.41429 9.91907C5.78937 10.2941 6.00008 10.8028 6.00008 11.3333C6.00008 11.5101 6.07032 11.6797 6.19534 11.8047C6.32037 11.9297 6.48994 11.9999 6.66675 11.9999C6.84356 11.9999 7.01313 11.9297 7.13815 11.8047C7.26318 11.6797 7.33341 11.5101 7.33341 11.3333C7.33211 10.7685 7.18698 10.2134 6.91171 9.72023C6.63644 9.22708 6.24011 8.81217 5.76008 8.51461ZM4.00008 7.99995C3.8023 7.99995 3.60896 7.9413 3.44451 7.83142C3.28006 7.72153 3.15189 7.56536 3.0762 7.38263C3.00051 7.1999 2.98071 6.99884 3.0193 6.80486C3.05788 6.61087 3.15312 6.43269 3.29297 6.29284C3.43283 6.15299 3.61101 6.05775 3.80499 6.01916C3.99897 5.98058 4.20004 6.00038 4.38276 6.07607C4.56549 6.15175 4.72167 6.27993 4.83155 6.44438C4.94143 6.60883 5.00008 6.80217 5.00008 6.99995C4.99973 7.26505 4.89426 7.5192 4.7068 7.70666C4.51934 7.89412 4.26519 7.99959 4.00008 7.99995Z" fill="#292929"/>
            </svg>
          </span>
          <p class="text-xs font-dark ml-1">Coverage</p>
        </div>
        <div class="flex justify-center items-center py-3">
          <Progress :value="percent" strokeColor="#5E60CE"></Progress>
        </div>
        <template>
          <div>
            <div class="flex items-center">
              <img src="@/assets/img/time-not-covered.svg" alt="" class="w-3">
              <p class="pl-1 text-xs">Time not covered</p>
            </div>
          </div>
          <div class="mt-2">
            <div class="flex items-center">
              <img src="@/assets/img/time-covered.svg" alt="" class="w-3">
              <p class="pl-1 text-xs">Time covered</p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// import EmptyState from './EmptyState.vue';
import license from '../license'
import specialties from '../specialties'
import SearchResults from './SearchResults.vue'
// import CoveredIcon from '../assets/img/time-covered.svg'
// import NotCoveredIcon from '../assets/img/time-not-covered.svg'
import Progress from "easy-circular-progress";

export default {
  components: {
    // EmptyState,
    SearchResults,
    Progress
  },
  data() {
    return {
      specialty: '',
      state_license: '',
      languages: '',
      insurance_coverage: '',
      percent: 65,
      allLisense: license,
      allSpecialties: specialties,
      insuranceCoverage: [
        {
          value: 'Kaiser Permanente',
          label: 'Kaiser Permanente'
        },
        {
          value: 'Anthem',
          label: 'Anthem'
        },
        {
          value: 'Aetna',
          label: 'Aetna'
        },
        {
          value: 'eHeealth',
          label: 'eHeealth'
        }
      ],
      allLanguages: [
        {
          value: 'French',
          label: 'French'
        },
        {
          value: 'English',
          label: 'English'
        },
        {
          value: 'Spanish',
          label: 'Spanish'
        },
        {
          value: 'Italian',
          label: 'Italian'
        },
        {
          value: 'Mandarin',
          label: 'Mandarin'
        }
      ],
      searchOptions: [
        {
          value: 'Option1',
          label: 'Option1'
        },
        {
          value: 'Option2',
          label: 'Option2'
        },
        {
          value: 'Option3',
          label: 'Option3'
        },
        {
          value: 'Option4',
          label: 'Option4'
        }
      ]
    }
  },
  methods: {
    next() {
      this.$emit('handleNext')
    },
    back() {
      this.$emit('handleBack')
      sessionStorage.setItem("back",true)
    },
  }
}
</script>

<style>
.vue-circular-progress .percent__dec {
  display: none;
}

.vue-circular-progress .dot {
  display: none;
}

.vue-circular-progress .percent__int {
  font-size: 19px;
}

.coverage {
  border-radius: 20px;
  width: 165px;
  position: absolute;
  right: 10px;
}
</style>